<template>
  <b-row class="animated fadeIn">
    <b-col sm="12">
      <form v-on:submit.prevent="submit">
        <b-card>
          <div slot="header">
            <strong>Form</strong>
            <small v-if="$route.name === 'Tambah Data Pembelian Obat'">Tambah Data Pembelian Obat</small>
            <small v-if="$route.name === 'Edit Data Pembelian Obat'">Edit Data Pembelian Obat</small>
          </div>
          <b-row v-if="isLoading">
            <b-col sm="12">
              Loading
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col sm="12">
              <div class="alert alert-danger" v-if="errors.all().length != 0">
                <strong>Perhatian</strong>
                <ul>
                  <li v-for="error in errors.all()">{{ error }}</li>
                </ul>
              </div>
            </b-col>
            <b-col sm="12">
              <b-form-fieldset label="Nomor Faktur" :label-cols="2" :horizontal="true">
                <input v-bind:disabled="id_pembelianObat != ''" name="nomor_faktur" class="form-control" data-vv-as="Nomor Faktur" v-bind:class="{ 'is-invalid': errors.has('nomor_faktur') }" v-validate="'required'" type="text" placeholder="Masukan nomor faktur" v-model="pembelianObat.nomor_faktur" />
              </b-form-fieldset>
            </b-col>

            <b-col lg="12">
              <b-form-fieldset label="Tanggal" :label-cols="2" :horizontal="true">
                <flat-pickr class="form-control col-sm-3 col-6" name="tanggal" v-bind:class="{ 'is-invalid': errors.has('tanggal') }" v-validate="'required'" v-model="pembelianObat.tanggal" :config="config" placeholder="Masukan tanggal pembelian"></flat-pickr>
              </b-form-fieldset>
            </b-col>

            <b-col sm="12">
              <b-form-fieldset label="Supplier" :label-cols="2" :horizontal="true">
                <input name="supplier" class="form-control" data-vv-as="Supplier" v-bind:class="{ 'is-invalid': errors.has('supplier') }" v-validate="'required'" type="text" id="supplier" placeholder="Masukan supplier" v-model="pembelianObat.supplier" />
              </b-form-fieldset>
            </b-col>

            <b-col lg="12">
              <b-form-fieldset label="Tanggal Jatuh Tempo" :label-cols="2" :horizontal="true">
                <flat-pickr class="form-control col-sm-3 col-6" name="jatuh_tempo" v-bind:class="{ 'is-invalid': errors.has('jatuh_tempo') }" v-validate="'required'" v-model="pembelianObat.jatuh_tempo" :config="config" placeholder="Masukan tanggal jatuh tempo"></flat-pickr>
              </b-form-fieldset>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <b-col sm="12">
            <b-form-fieldset label="Pembelian Obat" :label-cols="3" :horizontal="true">
              <button type="button" v-on:click="obat.push({})" class="btn btn-sm btn-primary"><i class="fa fa-plus"></i> Tambah Pembelian Obat</button>
              <button type="button" v-on:click="tambahMasterObat" class="btn btn-sm btn-warning"><i class="fa fa-medkit"></i> Tambah Master Obat</button>
              <span class="pull-right">Total Rp {{ totalObat | toCurrency }}</span>
            </b-form-fieldset>
          </b-col>

          <b-col sm="12">
            <table class="table table-striped">
              <tr>
                <th width="35%">Nama Obat</th>
                <th>No Batch</th>
                <th>Expired Date</th>
                <th>Harga Beli</th>
                <th>Jumlah</th>
                <th>Total</th>
                <th>Aksi</th>
              </tr>
              <tr v-for="item in obat">
                <td>
                  <v-select placeholder="[ Pilih Obat ]" :options="list_obat" v-model="item.obat"></v-select>
                </td>
                <td><input type="text" name="no_batch" v-model="item.no_batch" class="form-control"></td>
                <td><flat-pickr class="form-control" name="expired_date" v-bind:class="{ 'is-invalid': errors.has('expired_date') }" v-validate="'required'" v-model="item.expired_date" :config="config" placeholder="Expired Date"></flat-pickr></td>
                <td><money type="text" name="harga_beli" v-model="item.harga_beli" class="form-control"></money></td>
                <td><input type="text" name="jumlah" v-model="item.jumlah" class="form-control"></td>
                <td>
                  {{ item.harga_beli != null ? toCurrency(item.harga_beli * item.jumlah) : '' }}
                </td>
                <td><button type="button" v-on:click="obat.splice(obat.indexOf(item), 1)" class="btn btn-sm btn-danger"><i class="fa fa-times"></i></button></td>
              </tr>
            </table>
          </b-col>
        </b-card>

        <b-row>
          <b-col sm="12">
            <button v-if="id_pembelianObat === ''" @click="store" type="button" class="btn btn-block btn-success"><i class="fa fa-save"></i> Simpan</button>
            <button v-else @click="update" type="button" class="btn btn-block btn-warning"><i class="fa fa-save"></i> Edit</button>
          </b-col>
          <br />
          <br />
          <br />
        </b-row>
      </form>
    </b-col>

    <b-modal size="lg" title="Tambah Data Master Obat" v-model="myModal" @ok="storeObatNew">
      <b-col sm="12">
        <div class="alert alert-danger" v-if="errors.all().length != 0">
          <strong>Perhatian</strong>
          <ul>
            <li v-for="error in errors.all()">{{ error }}</li>
          </ul>
        </div>
      </b-col>
      <b-col sm="12">
        <b-form-fieldset label="Nama Obat" :label-cols="2" :horizontal="true">
          <input name="nama_obat" class="form-control" data-vv-as="Nama Obat" v-bind:class="{ 'is-invalid': errors.has('nama_obat') }" v-validate="'required'" type="text" id="name" placeholder="Masukan nama obat" v-model="obatBaru.nama_obat" />
        </b-form-fieldset>
      </b-col>

      <b-col sm="12">
        <b-form-fieldset label="Satuan" :label-cols="2" :horizontal="true">
          <b-form-select data-vv-as="Satuan" name="jenis_pasien" v-bind:class="{ 'is-invalid': errors.has('satuan') }" v-validate="'required'" class="col-sm-4" :plain="true" :options="list_satuan" v-model="obatBaru.satuan"></b-form-select>
        </b-form-fieldset>
      </b-col>

      <b-col sm="12">
        <b-form-fieldset label="Harga Jual" :label-cols="2" :horizontal="true">
          <money name="harga_jual" class="form-control" data-vv-as="Harga Jual" v-bind:class="{ 'is-invalid': errors.has('harga_jual') }" v-validate="'required|numeric'" type="text" id="harga_jual" placeholder="Masukkan harga jual" v-model="obatBaru.harga_jual"></money>
        </b-form-fieldset>
      </b-col>

      <b-col sm="12">
        <b-form-fieldset label="Minimum Stock" :label-cols="2" :horizontal="true">
          <input name="minimum_stock" class="form-control" data-vv-as="Minimum Stock" v-bind:class="{ 'is-invalid': errors.has('minimum_stock') }" v-validate="'required|numeric'" type="text" id="minimum_stock" placeholder="Masukan minimum stock" v-model="obatBaru.minimum_stock" />
        </b-form-fieldset>
      </b-col>
    </b-modal>
  </b-row>
</template>

<script>
  import Obat from '@/model/Obat'
  import PembelianObat from '@/model/PembelianObat'

  export default {
    data: () => {
      return {
        isLoading: false,
        usia: 0,
        id_pembelianObat: '',
        kode_pembelianObat: '',
        pembelianObat: {
          nomor_faktur: '',
          tanggal: '',
          supplier: '',
          jatuh_tempo: ''
        },
        obat: [],
        config: {
          dateFormat: 'd-m-Y',
          allowInput: true
        },
        list_obat: [],
        myModal: false,
        list_satuan: [
          { value: '', text: '[ Pilih Satuan ]' }, 'Box', 'Cream', 'Sirup', 'Strip', 'Tablet', 'Tube'
        ],
        obatBaru: {
          satuan: ''
        }
      }
    },
    methods: {
      async store () {
        try {
          var obat = []
          this.obat.forEach(function (e, i) {
            console.log(e)
            obat.push({
              id_obat: e.obat.e.id,
              harga: e.harga_beli,
              jumlah: e.jumlah,
              no_batch: e.no_batch,
              expired_date: e.expired_date
            })
          })

          var data = {
            pembelian_obat: this.pembelianObat,
            obat: obat
          }
          const pembelianObat = await PembelianObat.addPembelianObat(data)
          if (pembelianObat.data.status) {
            this.$router.replace('/pembelian-obat')
            this.$toastr.s('Tambah data pembelian obat berhasil')
          }
        } catch (e) {
          this.$toastr.e('Terjadi kesalahan pada server. Silahkan refresh halaman')
        }
      },
      async update () {
        try {
          var obat = []
          this.obat.forEach(function (e, i) {
            console.log(e)
            obat.push({
              id_obat: e.obat.e.id,
              harga: e.harga_beli,
              jumlah: e.jumlah,
              no_batch: e.no_batch,
              expired_date: e.expired_date
            })
          })
          var data = {
            pembelian_obat: this.pembelianObat,
            obat: obat
          }
          const pembelianObat = await PembelianObat.updatePembelianObat(this.id_pembelianObat, data)

          if (pembelianObat.data.status) {
            this.$router.replace('/pembelian-obat')
            this.$toastr.s('Edit data pembelian obat berhasil')
          }
        } catch (e) {
          this.$toastr.e('Terjadi kesalahan pada server. Silahkan refresh halaman')
        }
      },
      async getDetail () {
        var pembelianObat = await PembelianObat.getPembelianObatDetail(this.kode_pembelianObat)
        this.id_pembelianObat = pembelianObat.data.id
        this.pembelianObat = pembelianObat.data
        var detail = pembelianObat.data.detail_pembelian
        for (var i = 0; i < detail.length; i++) {
          var _obat = {
            no_batch: detail[i].no_batch,
            jumlah: detail[i].jumlah,
            expired_date: detail[i].expired_date,
            harga_beli: detail[i].harga,
            obat: {
              e: detail[i].obat,
              label: detail[i].obat.kode_obat + ' - ' + detail[i].obat.nama_obat + ' - ' + detail[i].obat.satuan
            }
          }
          this.obat.push(_obat)
        }
        this.isLoading = false
      },
      submit () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if (this.id_pembelianObat !== '') this.update()
            else this.store()
          }
        })
      },
      getDataObat () {
        var listObat = this.list_obat = []
        Obat.getAllObat().then((result) => {
          result.data.forEach(function (e, i) {
            listObat.push({
              e,
              label: e.kode_obat + ' - ' + e.nama_obat + ' - ' + e.satuan
            })
          })
        })
      },
      tambahMasterObat () {
        this.myModal = true
      },
      async storeObatNew () {
        try {
          const obat = await Obat.addObat(this.obatBaru)
          if (obat.data.status) {
            this.$toastr.s('Tambah data obat berhasil')
            this.getDataObat()
          }
        } catch (e) {
          this.$toastr.e('Terjadi kesalahan pada server. Silahkan refresh halaman')
        }
        this.myModal = false
      }
    },
    mounted () {
      this.getDataObat()
      this.kode_pembelianObat = this.$route.params.id
      if (this.kode_pembelianObat != null) {
        this.getDetail()
      }
    },
    computed: {
      totalObat: function () {
        var total = 0
        this.obat.forEach((val) => {
          if (val.harga_beli != null) total += parseInt(val.harga_beli) * parseInt(val.jumlah)
        })
        if (isNaN(total)) return 0
        return total
      }
    }
  }
</script>
